import type { SVGProps } from 'react';
export const SvgTelegram = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={40}
		height={40}
		fill="none"
		viewBox="0 0 40 40"
		{...props}
	>
		<rect width={40} height={40} fill="url(#a)" rx={10} />
		<path
			fill="#fff"
			fillRule="evenodd"
			d="M9.053 19.789q8.746-3.81 11.664-5.024c5.554-2.31 6.708-2.712 7.46-2.725.166-.003.536.038.776.233.202.164.258.386.284.541.027.156.06.51.034.788-.301 3.162-1.604 10.837-2.266 14.379-.28 1.498-.833 2-1.367 2.05-1.162.107-2.043-.767-3.168-1.505-1.76-1.154-2.755-1.872-4.464-2.998-1.974-1.301-.694-2.016.431-3.185.295-.306 5.412-4.96 5.511-5.383.012-.053.024-.25-.093-.354s-.29-.068-.414-.04q-.265.06-8.436 5.576-1.198.822-2.17.801c-.713-.015-2.087-.403-3.108-.735-1.253-.407-2.248-.623-2.161-1.314q.067-.54 1.487-1.105"
			clipRule="evenodd"
		/>
		<defs>
			<linearGradient
				id="a"
				x1={20}
				x2={20}
				y1={0}
				y2={39.703}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2AABEE" />
				<stop offset={1} stopColor="#229ED9" />
			</linearGradient>
		</defs>
	</svg>
);
